export function cardNumberFormatter(oldValue, newValue) {
  // user is deleting so return without formatting
  if (oldValue.length > newValue.length) {
    return newValue;
  }
  const currentValue = newValue.replace(/[^\d]/g, '');
  return currentValue
    .replace(/\W/gi, '')
    .replace(/(.{4})/g, '$1 ')
    .substring(0, 19);
}

export function expirationDateFormatter(oldValue, newValue) {
  // user is deleting so return without formatting
  if (oldValue.length > newValue.length) {
    return newValue;
  }
  const currentValue = newValue.replace(/[^\d]/g, '');
  return currentValue
    .replace(/\W/gi, '')
    .replace(/(.{2})/g, '$1/')
    .substring(0, 5);
}

export function phoneNumberFormatter(oldValue, newValue) {
  if (!newValue) return newValue;

  // only allows 0-9 inputs
  const currentValue = newValue.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  if (!oldValue || newValue.length > oldValue.length) {
    // returns: "x", "xx", "xxx"
    if (cvLength < 4) return currentValue;

    // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;

    // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
  }
  return '';
}
